import send from './send';
import { eventsKeys } from '../constants';

export default () => {
  send(eventsKeys.SIGN_UP_SMS);
};
